import { render } from "./CameraStatusInfo.vue?vue&type=template&id=61aebb4c&scoped=true&ts=true"
import script from "./CameraStatusInfo.vue?vue&type=script&lang=ts"
export * from "./CameraStatusInfo.vue?vue&type=script&lang=ts"

import "./CameraStatusInfo.vue?vue&type=style&index=0&id=61aebb4c&scoped=true&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aebb4c"]])

export default __exports__